##
# Use this with `number` or `range` type input. Example:
# <input type="number" wm-string-to-number ng-model="numberAsString">
#
##
angular
	.module 'App.Directive'
	.directive 'wmStringToNumber', ->
		require: 'ngModel',
		scope:
			castToFloat: '@?'
		link: (scope, element, attrs, ngModel) ->
			scope.getParsedNumberValue = (value) ->
				if value? and typeof value == 'string'
					value = if scope.castToFloat? then parseFloat(value) else parseInt(value)
				value

			ngModel.$parsers.push (modelValue) ->
				scope.getParsedNumberValue(modelValue)

			ngModel.$formatters.push (viewValue) ->
				scope.getParsedNumberValue(viewValue)
